import React, { useEffect, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import {
  Tabs,
  Row,
  Col,
  Input,
  DatePicker,
  Card,
  notification,
  Popover,
  message,
  InputNumber,
} from 'antd';

import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import TextArea from 'antd/lib/input/TextArea';
import TpAuthorizationSelect from 'components/TpAuthorizationSelect/TpAuthorizationSelect';
import TpAuthorizationUseSelect from 'components/AuthorizationListDetailSelect/AuthorizationListDetailSelect';
import InputCurrency from 'components/InputCurrency';
import Text from 'antd/lib/typography/Text';
import { getRounding, toCurrency, toRate } from 'utils/utils';
import UtinaCard from 'components/UtinaCard';
import Value from 'components/Value';
import ParListSelect from 'components/ParListSelect/ParListSelect';
import RateFormulaSelect from 'components/RateFormulaSelect';
import InputRate from 'components/InputRate/InputRate';
import {
  AssetRVCriteria,
  AssetUseCriteria,
  FilteringCriteria,
  ParAssetUseRequest,
  getOfferDetailByOfferId,
  getParAssetUseByFilters,
  getPricingDetail,
  getPricingPackDetail,
  getprOfferDetailByOfferId,
  getprOfferList,
  getprOfferListByPrcodeAndMgid,
  prFilteringCriteria,
} from 'services/pricing';
import moment from 'moment';
import { dateToString, objectParValueToString, unGroup } from 'utils/utils2';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Form from 'antd/lib/form';
import AssetsTable from 'pages/ProposalV3/PropDetail/AssetsTable';
import { useModalState } from 'hooks/useModalState';
import SimpleAssetModal, {
  SimpleAssetModalProps,
} from 'pages/ProposalV3/PropDetail/SimpleAssetModal';
import AssetCatalogPackModal from 'components/AssetCatalogPackModal';
import AssetCatalogModal from 'components/AssetCatalogModal';
import AssetListModalV from 'pages/Asset/AssetListModalV2';
import _, { groupBy, isEmpty, isNil, sumBy } from 'lodash';
import { assetCatalogToAsset } from 'pages/ProposalV3/PropDetail/assetCatalogToAsset';
import {
  getAssetCatalogRvAmountList,
  getAssetRvAmountList,
} from 'services/assetconfig';
import getEnvValue from 'utils/getEnvValue';
import { getMgParValueByParCode } from 'services/parametersService';
import { useQuery } from 'react-query';
import { TpAuthorizationDetailResponse, getThirdPartyAuthorizationListByTpid } from 'services/thirdParty';
import { assetSearchToAsset } from 'pages/ProposalV3/PropDetail/assetSearchToAsset';
import { getAssetUseByAssetID } from 'services/assets';
import { commissionToElement } from 'pages/ProposalV3/PropDetail/commissionToElement';
import { pricingToElement } from 'pages/ProposalV3/PropDetail/pricingToElement';
import { ConElemPrefinStepRequest, PropElementRequest } from 'services/proposal';
import ModalControllerNV from 'components/ModalControllerNV';
import ButtonOperation from 'components/ButtonOperation';
import ConElemPrefinStepModal from 'pages/ProposalV3/PropDetail/components/ConElemPrefinStepModal';
import DataGrid from 'components/DataGrid';
import PopoverController from 'components/PopoverController';
import DeleteButton from 'components/DeleteButton';
import * as finEngine from 'services/finEngine';
import ThirdPartyInput from 'components/ThirdPartyInput';
import { offerPrefinstepToElementStep } from 'pages/ProposalV3/PropDetail/offerPrefinstepToPrefinElementStep';
import { offerToElement } from 'pages/ProposalV3/PropDetail/offerToElement';
import ScheduleButton from 'components/ScheduleButton';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ThirdpartyAuthBeneficiarySelect from 'pages/ThirdParty/ThirdpartyAuthBeneficiarySelect.';

const { TabPane } = Tabs;

export type TabTPAddressProps = {
  objectid: number;
  entityName: string;
  entityReference: string;
  clientName: string;
  form: FormInstance;
  setSuccessful: any;
};

const TabTpAuthorizationUse = ({
  objectid,
  entityName,
  entityReference,
  clientName,
  form,
  setSuccessful,
}: TabTPAddressProps) => {
  const [tpAuth, setTpAuth] = useState<any>();

  const [tpAuthDetail, setTpAuthDetail] = useState<any[]>();
  const [authBeneficiaryList, setAuthBeneficiaryList] = useState<any[]>();

  const [loading, setLoading] = useState<boolean>(false);

  const [assetModalVisible, setAssetModalVisible] = useState(false);
  const [prcode, setPrcode] = useState<string>('');
  const [assetstatus, setassetstatus] = useState('');
  const [displayAssets, setDisplayAssets] = useState<boolean>(true);

  const [assetClass, setAssetClass] = useState('');

  const [prefinmethod, setPrefinmethod] = useState('');
  const [finElement, setFinElement] = useState<any>();

  const calculatePaymentShedulePrefinSteps = (finElement: any) => {
    let FinElemStep = form.getFieldValue('_prefinStepsList') ?? [];

    // calculate FIN
    var finamount = 0;

    const investamount = finElement.cteinvestamount;
    // const firstPayment = finElement.ctefirstpayment;
    // const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    const extracost =
      finElement.cteextracosttofinance == null
        ? 0
        : finElement.cteextracosttofinance;

    finamount = investamount + extracost - upfront - part;

    if (isNil(FinElemStep) || FinElemStep.length === 0) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      FinElemStep.forEach((s: ConElemPrefinStepRequest) => {
        s.ctesoutstandingamount = (finamount * s.ctesoutstandingcoef) / 100;
      });

      setLoading(true);
      finEngine
        .calculatePaymentShedulePrefinSteps({
          finReq: {
            elementStep: form.getFieldValue('_prefinStepsList') ?? [],
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:form.getFieldValue('ctepartnbdays')??0,
              //finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:form.getFieldValue('ctepartrate')??0,
              //finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
          inPartInvoicingMode:finElement?.ctepartinvoicingmode,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoading(false);
          if (res.success) {
            // calculateServAndComm(res, finElement, finamount, inCteid);
            message.success(res.message);

            setFinElement({
              ...finElement,
              conElemSchedules: res.paymentSchedule,
              ctedeferredinterestnominalrate: res.inDeferredRate,
              ctedeferredinterest: res.deferredInterest,
              ctedepositnominalrate: res.inDepositRate,
              ctedepositinterest: res.depositInterest,
              cteactuarialrate: res.effectiverate,
              ctervamount: 0,
              ctervcoef: 0,
              ctefirstpayment: 0,
              ctefirstpaymentcoef: 0,
            });
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :


  const onSavePreFinElement = (offerPrefinStep: any, action: string) => {
    if (action === 'create') {
      
      ///
      const _prefinStepList = form.getFieldValue('_prefinStepsList');
      const finamount = form.getFieldValue('amountToUse');
      
      _prefinStepList.push({
        ...offerPrefinStep,
        /*ctesoutstandingamount:
          (investamount * offerPrefinStep.ctesoutstandingcoef) / 100,*/
      });
      
      form.setFieldValue('_prefinStepsList', _prefinStepList);

    }
      ////
      
      
      
    if (action === 'update') {
     
      const _prefinStepList = form.getFieldValue('_prefinStepsList');

      const newConelemprefinstepList: any[] = [];
      _prefinStepList.forEach((e: any) => {
        if (e.ctesid === offerPrefinStep.ctesid) {
          newConelemprefinstepList.push({
            ...offerPrefinStep,
           
          });
        } else {
          newConelemprefinstepList.push(e);
        }
      });

      form.setFieldValue('_prefinStepsList', newConelemprefinstepList);
     
    }
  };

  const getFilterList = (): prFilteringCriteria => {
    let assetList = form?.getFieldValue('assets');

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let assetRVCriteriaList: Array<AssetRVCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;

    offerCriteriaList.push({
      critcode: 'PROPORIGIN',
      critvalue: form?.getFieldValue('ctproporigin') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'DEALRATING',
      critvalue: form?.getFieldValue('ctdealerrating') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'NASSETS',
      critvalue: form?.getFieldValue('assets')?.length ?? '0',
    });

    const duration = form
      ?.getFieldValue(['elements', 'FIN'])
      ?.filter(
        (e: any) => e.cteid === form?.getFieldValue('selectedElement')
      )[0]?.cteduration;

    offerCriteriaList.push({
      critcode: 'DURATION',
      critvalue: duration ?? 48,
    });

    const invest = sumBy(form?.getFieldValue('assets'), 'assetnetamount');

    offerCriteriaList.push({
      critcode: 'INVEST',
      critvalue: String(invest) ?? '0',
    });

    //PROPORIGIN

    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });

    assetList?.forEach((a: any) => {
      assetRVCriteriaList.push({
        catalogid: a.catalogid,
        assetid: a.assetid,
        assetsegment: a.assetsegment,
        assetfamily: a.assetfamily,
        assettype: a.assettype,
        assetcategory: a.assetcategory,
        assetmodel: a.assetmodel,
        assetbrand: a.assetbrand,
        assetbrandmodel: a.assetbrandmodel,
        assetnetamount: a.assetnetamount,
        assetfinamount: a.assetfinamount,
        assetvariant: a.assetvariant,
        // assetclass :a.assetclass,
      });

      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({
        critcode: 'FLAGUSED',
        critvalue: a.flagused ?? '',
      });

      offerCriteriaList.push({
        critcode: 'ASSETCLASS',
        critvalue: a.assetclass ?? '',
      });

      a.power != null ??
        offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        e.attstringvalue !== null
          ? offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attstringvalue,
            })
          : e.attnumericvalue !== null ??
            offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attnumericvalue,
            });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: prcode,
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer:
        assetList && assetList.length > 0
          ? assetList![0]?.tpidmanufacturer ?? 0
          : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: assetRVCriteriaList,
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const { data:tpAuthList, refetch } = useQuery(
    ['getThirdPartyAuthorizationListByTpid', { tpid: Number(objectid) }],
    () =>
      getThirdPartyAuthorizationListByTpid({ tpid: Number(objectid) }).then(
        (res) => {
          if (res?.list?.length > 0) {
            form.setFieldValue('authid', res.list[0].authid);
            setTpAuth(res.list[0]);
            setPrcode(res.list[0]?.authDetail[0]?.prcode);

            console.log(
              'res.list[0]?.authDetail[0]?.prcode',
              res.list[0]?.authDetail[0]?.prcode
            );
            refetchOffers();
          }
          return res.list || [];
        }
      ),
    { enabled: !!objectid }
  );

  const {
    data: offers,
    isFetching: isLoading,
    refetch: refetchOffers,
  } = useOfferList({
    prcode: prcode,
    duration: form.getFieldValue('duration'),
    finamount: form.getFieldValue('amountToUse'),
    filters: '',
    filtersList: getFilterList(),
    searchMode: 'PRCODE',
  });

  const loadOfferDetail = (offerid: number) => {
    return getprOfferDetailByOfferId({
      offerid: offerid,
      filtersList: getFilterList(),
    });
  };

  useEffect(() => {
    form.setFieldValue('event', 'tabTpAuthorizationUse');
  }, [offers]);

  const setBeneficiaries=(autDetail:TpAuthorizationDetailResponse)=>{
    
    var ListBenef:Array<{tpid:number,tpname:string}>=[];
    
    ListBenef.push({"tpid":objectid,"tpname":entityName});
    autDetail.tpAuthorizationDetailRules.map((e)=>{
      ListBenef.push({"tpid":e.tpidbeneficiary,"tpname":e.beneficiaryname});
    })

    setAuthBeneficiaryList(ListBenef);

  }

  const setAuthDetail=(e:number) =>{
    

   const filteredAuthDetailList: TpAuthorizationDetailResponse[]|undefined = tpAuthList?.filter(
      (authdetail: any) => authdetail.authid === e
    )[0]?.authDetail;

  
    setTpAuthDetail(filteredAuthDetailList);

  }
  const loadAssetAuthUse = async () => {
    await getMgParValueByParCode({
      parcode: 'ASSETINAUT',
    })
      .then((response) => {
        if (response.data != null) {
          setDisplayAssets(response.data.parvaluemin === 'true');
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    loadAssetAuthUse();
    if (displayAssets) {
      setSuccessful(true);
    }
  }, []);

  const catalogModal = useModalState();
  const catalogPackModal = useModalState();
  const simpleAssetModal = useModalState();

  const initialValues = {
    assets: [],
    _prefinStepsList: [],
  };

  const handleAddFromCatalog = () => {
    catalogModal.open();
  };

  const handleAddFromCatalogPack = () => {
    catalogPackModal.open();
  };

  const handleCreateNewAsset = () => {
    simpleAssetModal.open();
  };
  const handleCreateNewMultiCompAsset = () => {
  };

  const handleAddFromStock = () => {
    // setassetphase('PROD');
    // setassetstatus('STOCK');
    setAssetModalVisible(true);
  };
  const handleAddInitAsset = () => {
    // setassetphase('PROPOSAL');
    // setassetstatus('INIT');

    // assetListModal.open();
    setAssetModalVisible(true);
  };

  const handleDeleteElement = (record: any) => {
    // form?.getFieldValue('elements');

    const obj = form
      ?.getFieldValue(['elements', String(record?.ctetype)])
      ?.filter((element: any) => element.cteid !== record.cteid);

    let elements = form.getFieldValue('elements');

    switch (String(record?.ctetype)) {
      case 'COMM':
        elements = { ...elements, COMM: obj };
        break;
      case 'FEES':
        elements = { ...elements, FEES: obj };
        break;
      case 'FIN':
        elements = { ...elements, FIN: obj };
        break;
      case 'FINSERV':
        elements = { ...elements, FINSERV: obj };
        break;
      case 'SERV':
        elements = { ...elements, SERV: obj };
        break;
    }

    form.setFieldsValue({ elements: elements });
    if (record?.ctetype === 'FIN' || record?.ctetype === 'SPV') {
      handleDeleteFinChildElements(record.cteid);
      //deleting linked assets
      const newAssets = form
        .getFieldValue('assets')
        .filter((asset: any) => asset.cteid !== record.cteid);
      form.setFieldsValue({
        assets: newAssets,
        ctfinancedamount: sumBy(newAssets, 'assetfinamount'),
      });
    }
  };
  const handleDeleteAsset = (assetId: number) => {
    const cteid = form.getFieldValue('selectedElement');
    const tpidsupplier = form
      .getFieldValue('assets')
      .find((asset: any) => asset.assetid === assetId).tpidsupplier;
    const newAssets = form
      .getFieldValue('assets')
      .filter((asset: any) => asset.assetid !== assetId);
    const linkedAssets = newAssets.filter(
      (asset: any) => asset.cteid === cteid
    );
    form.setFieldsValue({
      assets: newAssets.map((asset: any) => {
        if (asset.cteid === cteid) return { ...asset, assetrvamount: 0 };
        else return { ...asset };
      }),
      ctfinancedamount: sumBy(newAssets, 'assetfinamount'),
    });

    if (
      (form.getFieldValue('prcode') !== 'LEASEBACK' ||
        newAssets.length === 0) &&
      newAssets.find((asset: any) => asset.tpidsupplier === tpidsupplier) ===
        undefined
    ) {
      const newTP = form
        .getFieldValue('thirdparties')
        .filter(
          (tp: any) =>
            tp.tpid.tpid !== tpidsupplier || tp.tprolecode !== 'SUPPLIER'
        );
      const newSUP = newTP.find((tp: any) => tp.tprolecode === 'SUPPLIER');
      form.setFieldsValue({
        thirdparties: newTP,
        supplier: newSUP === undefined ? null : newSUP,
      });
    }

    let elements = form.getFieldValue('elements');
    if (elements && Object.keys(elements).length > 0) {
      if (linkedAssets.length === 0) {
        handleDeleteElement(
          form.getFieldValue('prcode') === 'SPV'
            ? form
                ?.getFieldValue(['elements', 'SPV'])
                ?.find((ele: any) => ele.cteid === cteid)
            : form
                ?.getFieldValue(['elements', 'FIN'])
                ?.find((ele: any) => ele.cteid === cteid)
        );
      } else if (form?.getFieldValue('ctfclevel') === 'MULTI') {
        let finelements: any[] = form
          .getFieldValue(['elements', 'FIN'])
          .map((ele: any) => {
            if (ele.cteid === cteid) {
              return {
                ...ele,
                cteinvestamount: sumBy(
                  newAssets.filter((asset: any) => asset.cteid === cteid),
                  'assetfinamount'
                ),
                ctevatdeferralamount: sumBy(
                  newAssets.filter((asset: any) => asset.cteid === cteid),
                  'assettaxamount'
                ),
              };
            } else return ele;
          });
        elements = { ...elements, FIN: finelements };

        form.setFieldsValue({ elements: elements });
        let fin = form
          .getFieldValue(['elements', 'FIN'])
          .find((e: any) => e.cteid === cteid);

        if (fin.ofrid !== 0) {
          handlePricingChange(
            {
              ofrid: fin.ofrid,
              ofrtype: fin.ofrtype,
              ofrlabel: fin.ofrlabel,
            },
            '',
            0
          );
        } else {
          handleOfferChange(form.getFieldValue('offerid'));
        }
      }

      form.setFieldsValue({
        ctfinancedamount: sumBy(form.getFieldValue('assets'), 'assetfinamount'),
        // ctefinancedamount: sumBy(form.getFieldValue('assets'), 'assetnetamount'),
      });
      if (form.getFieldValue('ctfclevel') === 'PROPOSAL') {
        form.setFieldsValue({
          offerid: null,
          pricing: null,
          elements: [],
          syndication: [],
          ctsyndinvoicingtype: null,
          ctsyndsuppliermanagementtype: null,
          ctsyndpaymentmanagementtype: null,
          ctsyndmgcoef: 0,
          ctsyndmgpartamount: 0,
        });
      }
      // else debouncedCalculateNew('', '');
    }
    setAssetClass('');
  };

  const getName = (param: string, cteid: any) => {
    let lcteid = form.getFieldValue('selectedElement');

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, param];
    } else {
      if (form.getFieldValue(['elements', 'FIN'])) {
        const index = form
          .getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item.cteid === lcteid);
        return ['elements', 'FIN', index, param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };
  const loadPricingDetail = (pricing: any) => {
    let finamount = form.getFieldValue(getName('cteinvestamount', 1));
    if (
      form.getFieldValue('flagasset') !== true &&
      form.getFieldValue('ctfclevel') === 'PROPOSAL'
    )
      finamount = form.getFieldValue('ctfinancedamount');

    if (pricing.ofrtype === 'PACK') {
      return getPricingPackDetail({
        filtersList: getFilterList(),
        packid: pricing.ofrid,
      });
    } else {
      return getPricingDetail({
        filtersList: getFilterList(),
        priid: pricing.ofrid,
      });
    }
  };
  const handleAssetuseByOfferidORPricing = async (
    offerid: number,
    ofrid?: number,
    ofrtype?: string
  ) => {
    const listassets = form.getFieldValue('assets');
    const cteid = form.getFieldValue('selectedElement');

    const listAssetElement = listassets.filter((e: any) => e.cteid === cteid);

    const requestParams = listAssetElement.map(
      (asset: any): ParAssetUseRequest => ({
        assetid: asset.assetid,
        catalogid: asset.catalogid,
        assetfamily: asset.assetfamily,
        assettype: asset.assettype,
        assetcategory: asset.assetcategory,
        prcode: form.getFieldValue('prcode'),
        offerid: offerid,
        ofrtype: ofrtype ?? ('' as any),
        ofrid: ofrid ?? ('' as any),
      })
    );

    await getParAssetUseByFilters({
      parAssetRequest: requestParams,
    }).then((res) => {
      if (!isNil(res.list) && !isEmpty(res.list)) {
        form.setFieldsValue({
          assets: listassets.map((asset: any) => {
            if (asset.cteid === cteid) {
              let linkedListOfUse = res.list
                .filter((use: any) => use.assetid === asset.assetid)
                .map((use: any) => ({ ...use, usevalue: use.defaultvalue }));
              return {
                ...asset,
                assetusereqList: _.values(
                  _.merge(
                    _.keyBy(linkedListOfUse, 'useid'),
                    _.keyBy(asset.assetusereqList, 'useid')
                  )
                ),
              };
            } else return asset;
          }),
        });
      }
    });
  };

  const handleDeleteFinChildElements = (cteid: number) => {
    const elementsByType = form.getFieldValue('elements') ?? {};

    const oldElements = unGroup(elementsByType).filter(
      (item: any) => item.cteidparent !== cteid
    );

    const {
      FIN = [],
      SERV = [],
      FEES = [],
      COMM = [],
      FINSERV = [],
    } = groupBy(oldElements, 'ctetype');

    form.setFieldsValue({
      elements: {
        COMM,
        FEES,
        FIN,
        FINSERV,
        SERV,
      },
    });
  };

  const handlePricingChange = async (
    pricing: any,
    inPartmethod: any,
    inPartamount: any,
    noCalcul?: boolean
  ) => {
    if (pricing !== undefined) {
      if (form.getFieldValue('flagasset') === true) {
        await handleAssetuseByOfferidORPricing(
          form.getFieldValue('offerid'),
          pricing.ofrid,
          pricing.ofrtype
        );
      }
      loadPricingDetail(pricing)
        .then((res: any) => {
          const pricings = res.list;

          const data = pricings.find(
            ({ ctetype }: any) => ctetype === 'FIN' || ctetype === 'SPV'
          );

          if (inPartmethod === 'REDUCEFIN') {
            if (data) {
              data.partmethod = 'REDUCEFIN';
              data.partamount = inPartamount ?? 0;
            }
          }
          const cteid = form.getFieldValue('selectedElement');

          handleDeleteFinChildElements(cteid);

          const listassets = form.getFieldValue('assets');
          const listAssetElement = listassets.filter(
            (e: any) => e.cteid === cteid
          );
          const listAssetOtherElement = listassets.filter(
            (e: any) => e.cteid !== cteid
          );
          let indexElement = -1;

          const finElements = form.getFieldValue(['elements', 'FIN']) || [];

          if (finElements.length !== 0) {
            indexElement =
              finElements.findIndex((item: any) => item.cteid === cteid) ?? 0;
          }

          let investamount = form.getFieldValue('ctfinancedamount');
          let taxamount = 0;

          if (form.getFieldValue('ctfclevel') !== 'PROPOSAL') {
            if (form.getFieldValue('flagasset')) {
              // get list of associated assets
              investamount = sumBy(listAssetElement, 'assetfinamount');
              taxamount = sumBy(listAssetElement, 'assettaxamount');
            } else {
              if (indexElement >= 0) {
                investamount = finElements[indexElement].cteinvestamount;
                taxamount = finElements[indexElement].ctevatdeferralamount;
              }
            }
          }

          let commList: Array<PropElementRequest> = [];

          let rvcoef = 0;
          let rvamount = 0;

          //form.setFieldsValue({rvcalculationmode:data!.rvcalculationmode,rvevaluationmode:data!.rvevaluationmode})
          if (data && data!.rvcalculationmode === 'ASSET') {
            let totalAssetRV = 0;
            let assetrvamount = 0;
            let newRvAmount = 0;
            const defaultduration = data.durationdefault;

            listAssetElement.forEach((asset: any) => {
              const lineRV = (assetrvamount = asset.listrv.filter(
                (lrv: any) =>
                  defaultduration >= lrv.monthsmin &&
                  defaultduration <= lrv.monthsmax &&
                  //lrv.rvevaluationmode === finElements.rvevaluationmode &&
                  lrv.rvtype === 'FIN'
              )[0]);
              assetrvamount = lineRV?.rvamount;
              if (lineRV?.rvevaluationmode !== 'FIXED')
                newRvAmount = isNaN(assetrvamount) ? 0 : assetrvamount;
              else
                newRvAmount = isNaN(assetrvamount)
                  ? 0
                  : assetrvamount * asset.assetqty;
              asset.assetrvamount = newRvAmount;
              totalAssetRV = totalAssetRV + newRvAmount;
            });

            rvcoef = (totalAssetRV / investamount) * 100;
            rvamount = totalAssetRV;
          } else {
            // use FIN ELEMENT rv :
            if (data!.rvevaluationmode === 'FIXED') {
              rvamount = data!.rvdefaultamount;
              rvcoef = (rvamount / investamount) * 100;
            } else {
              rvcoef = data!.rvdefault;
              rvamount = (data!.rvdefault * investamount) / 100;
            }
          }

          form.setFieldsValue({
            assets: [...listAssetOtherElement, ...listAssetElement],
          });

          // eslint-disable-next-line array-callback-return
          let newElements = pricings.map((item: any) => {
            if (item.ctetype === 'COMM') {
              commList.push(
                commissionToElement(
                  pricing,
                  item,
                  item.commissionResponse,
                  cteid,
                  investamount
                )
              );
            } else {
              if (item.commissionList?.length !== 0) {
                item.commissionList?.map((c: any) =>
                  commList.push(
                    commissionToElement(pricing, item, c, cteid, investamount)
                  )
                );
              }
              return pricingToElement(
                pricing,
                item,
                investamount,
                taxamount,
                rvamount,
                rvcoef,
                item.ctetype === 'FIN' || item.ctetype === 'SPV' ? cteid : 0,
                cteid
              );
            }
          });
          commList.forEach((e) => {
            newElements.push(e);
          });

          const elementsByType = form.getFieldValue('elements') ?? {};

          if (
            form.getFieldValue('ctfclevel') === 'MULTI' &&
            finElements[indexElement]?.ctedescription !== '' &&
            !isNil(finElements[indexElement]?.ctedescription)
          ) {
            newElements = newElements.map((ele: any) => {
              if (ele?.cteid === finElements[indexElement]?.cteid)
                return {
                  ...ele,
                  ctedescription: finElements[indexElement]?.ctedescription,
                };
              else
                return {
                  ...ele,
                };
            });
          }
          const oldElements = unGroup(elementsByType).filter(
            (item: any) => item.cteid !== cteid
          );

          // const finalElemList = { ...oldElements, ...newElements };
          const finalElemList = oldElements.concat(newElements);

          const {
            FIN = [],
            FINOUT = [],
            SPV = [],
            SERV = [],
            FEES = [],
            COMM = [],
            FINSERV = [],
            SERVOUT = [],
          } = groupBy(finalElemList, 'ctetype');
          if (data != null) {
            let newElements: any = {
              COMM,
              FEES,
              FIN,
              FINOUT,
              SPV,
              FINSERV,
              SERV,
              SERVOUT,
            };
            form.setFieldsValue({
              elements: newElements,
            });
            // debouncedCalculateNew('', '');
          } else {
            let ofr = form.getFieldValue('offerid');
            handleOfferChange(ofr);
            notification.error({
              message: 'No Pricing Financing Element associated to this Pack',
              description: '',
              duration: 10,
            });
          }
          // setIsLoading(false);
        })
        .catch(() => {
          // setIsLoading(false);
        });
    }
  };

  const handleSelectAssetFromStockOrInit = async (assetList: any[]) => {
    setAssetModalVisible(false);

    await Promise.all(
      assetList.map(async (assetCatalog, index) => {
        let listrv: any[] = [];

        const listuse = await getAssetUseByAssetID({
          assetid: assetCatalog.assetid ?? '',
        }).then((res: any) => res.list);

        const cteid = form.getFieldValue('selectedElement');

        if (form.getFieldValue('prcode') === 'LEASEBACK') {
          let client = form.getFieldValue('client');
          if (client && typeof client == 'object') {
            assetCatalog.suppliername = client?.tpname;
            assetCatalog.supplierreference = client?.reference;
            assetCatalog.tpidsupplier = client?.tpid;
          }
        }
        const asset = assetSearchToAsset(
          assetCatalog,
          listrv,
          assetCatalog.assetqty,
          cteid,
          'free',
          listuse
        );

        form.setFieldsValue({
          supplier: {
            tpid: assetCatalog.tpidsupplier,
            tpname: assetCatalog.suppliername,
            tpreference: assetCatalog.supplierreference,
          },
          ctpower: assetCatalog.kwhpower,
          ctproduction: assetCatalog.kwhproduction,
          ctdegradation: assetCatalog.kwhdegradation,
          ctdeliveryadrzipcode: assetCatalog.deliveryadrzipcode,
          ctdeliveryadrcity: assetCatalog.deliveryadrcity,
        });

        let client = form.getFieldValue('client');
        if (
          form.getFieldValue('prcode') === 'LEASEBACK' &&
          (client == null || client !== undefined)
        ) {
          form.setFieldsValue({
            client: {
              tpid: assetCatalog.tpidsupplier,
              tpname: assetCatalog.suppliername,
              tpreference: assetCatalog.supplierreference,
            },
          });
        }

        const assets: any[] = form.getFieldValue('assets');

        if (assets.length === 0) {
          setAssetClass(asset.assetclass);
        }

        if (form.getFieldValue('ctfclevel') === 'PROPOSAL') {
          form.setFieldsValue({
            assets: [
              ...(form.getFieldValue('assets').map((asset: any) => {
                return { ...asset, assetrvamount: 0 };
              }) || []),
              asset,
            ],
            assetpictureurl: asset.assetpictureurl,
          });
        } else {
          form.setFieldsValue({
            assets: [...form.getFieldValue('assets'), asset],
            assetpictureurl: asset.assetpictureurl,
          });
        }

        form.setFieldsValue({
          ctfinancedamount: sumBy(
            form.getFieldValue('assets'),
            'assetfinamount'
          ),
          mfrequestedamount: sumBy(
            form.getFieldValue('assets'),
            'assetfinamount'
          ),
        });
        let elements = form.getFieldValue('elements');

        if (form.getFieldValue('ctfclevel') === 'MULTI') {
          let finelements = form.getFieldValue(['elements', 'FIN']);
          finelements.forEach((ele: any) => {
            if (ele?.cteid === cteid) {
              ele.cteinvestamount = ele.cteinvestamount + asset.assetfinamount;
              ele.ctevatdeferralamount =
                ele.ctevatdeferralamount + asset.assettaxamount;
            }
          });

          elements = { ...elements, FIN: finelements };

          form.setFieldsValue({ elements: elements });

          let fin = form
            .getFieldValue(['elements', 'FIN'])
            .find((e: any) => e.cteid === cteid);
          if (index === assetList.length - 1)
            if (fin.ofrid !== 0) {
              handlePricingChange(
                {
                  ofrid: fin.ofrid,
                  ofrtype: fin.ofrtype,
                  ofrlabel: fin.ofrlabel,
                },
                '',
                0
              );
            } else {
              handleOfferChange(form.getFieldValue('offerid'));
            }
        } else {
          // (form.getFieldValue('ctfclevel') === 'PROPOSAL') {

          form.setFieldsValue({
            offerid: null,
            pricing: null,
            elements: [],
            syndication: [],
            ctsyndinvoicingtype: null,
            ctsyndsuppliermanagementtype: null,
            ctsyndpaymentmanagementtype: null,
            ctsyndmgcoef: 0,
            ctsyndmgpartamount: 0,
          });
        }
      })
    ).catch(() => {
      setAssetModalVisible(true);
    });

    let assets: any[] = form.getFieldValue('assets');
    let newListAsset: any[] = [];

    await Promise.all(
      assets.map(async (asset) => {
        if (
          assetList.findIndex(
            (assetCatalog) => assetCatalog.assetid === asset.assetid
          ) !== -1
        ) {
          let listrv = [];

          if (!isNil(asset?.catalogid)) {
            listrv = await getAssetCatalogRvAmountList({
              prcode: form.getFieldValue('flagmasterfacility')
                ? form.getFieldValue('mfprcode')
                : form.getFieldValue('prcode') ?? '',
              catalogid: asset.catalogid ?? '',
              assetamount: asset.assetfinamount,
              filters: getFilterList(),
            }).then((res: any) => res.list);
          } else {
            listrv = await getAssetRvAmountList({
              assetid: asset.assetid,
              prcode: form.getFieldValue('flagmasterfacility')
                ? form.getFieldValue('mfprcode')
                : form.getFieldValue('prcode') ?? '',
              assettype: asset.assettype,
              assetcat: asset.assetcategory,
              assetamount: asset.assetfinamount,
              filters: getFilterList(),
            }).then((res: any) => res.list);
          }

          newListAsset.push({
            ...asset,
            listrv: listrv,
          });
        } else {
          newListAsset.push(asset);
        }
      })
    );

    form.setFieldValue('assets', newListAsset);
  };

  const getAssetListId = () => {
    let list: Array<Number> = [];

    form.getFieldValue('assets')?.map((e: any) => list.push(e?.assetid));

    return list;
  };

  const handleOfferChange = (offerid: number) => {
    getOfferDetailByOfferId({ offerid }).then((res) => {
      if (res.data != null) {
        let calctype = res.data.calculationmethod;
        form.setFieldsValue({
          duration: res.data.durationdefault,
          periodicity:
            calctype === 'PREFIN'
              ? res.data.prefinperiodicity
              : res.data.periodicity,
          calculationtype: calctype,
          ratetype:
            calctype === 'PREFIN' ? res.data.prefinratetype : res.data.ratetype,
          rateformula:
            calctype === 'PREFIN'
              ? res.data.prefinrateformula
              : res.data.rateformula,
          rateref:
            calctype === 'PREFIN'
              ? res.data.prefinrateref
              : res.data.ratevaluedefault,
          ratespread:
            calctype === 'PREFIN'
              ? res.data.prefinratespreaddefault
              : res.data.ratespreaddefault,
          nominalrate:
            calctype === 'PREFIN'
              ? res.data.prefinnominalrate
              : res.data.ratespreaddefault + res.data.ratevaluedefault,
        });
        
        setPrefinmethod(res.data.prefinmethod);

        const _prefinStepList = res?.data?.prefinStepList ?? [];
        const finamount = form.getFieldValue('amountToUse');
        const conElemPrefinSteps = offerPrefinstepToElementStep(
          _prefinStepList,
          finamount
        );

        form.setFieldsValue({'_prefinStepsList':conElemPrefinSteps,
        'ctepartmethod':res.data.partmethod,
        'ctepartrate':res.data.partrate,
        'ctepartnbdays':res.data.partnbdays,
        'ctepartnbdaysmax':res.data.partnbdaysmax,
        'tpidparticipation':{'tpid':res.data.tpidparticipation,
                      'tpname':res.data.tpnameparticipation,
                      'tpreference':res.data.tpreferenceparticipation,}
        });

        let Element2 = offerToElement(
          res?.data,
          finamount,
          0,
          0,
          false,
          form.getFieldValue('ctepartmethod'),
          form.getFieldValue('ctepartamount'),
          0
        );

        setFinElement(Element2);

      }
    });
  };

  const handleAddSimpleAsset: SimpleAssetModalProps['onAdd'] = async (
    simpleasset
  ) => {
    if (form) {
      const listrv = await getAssetRvAmountList({
        assetid: 0,
        prcode: 'WHOLESALE',
        assettype: simpleasset.assettype,
        assetcat: simpleasset.assetcategory,
        assetamount: simpleasset.assetnetamount,
        filters: getFilterList(),
      }).then((res: any) => res.list);

      const listuse = await getParAssetUseByFilters({
        parAssetRequest: [
          {
            assetcategory:
              objectParValueToString(simpleasset.assetcategory) ?? '',
            assetfamily: objectParValueToString(simpleasset.assetfamily) ?? '',
            assetid: '' as any,
            assettype: objectParValueToString(simpleasset?.assettype) ?? '',
            catalogid: simpleasset.catalogid ?? '',
            offerid: '' as any,
            ofrid: '' as any,
            ofrtype: '',
            prcode: 'WHOLESALE',
          },
        ],
      }).then((res: any) => res.list);

      const cteid = form.getFieldValue('selectedElement');

      const asset = assetCatalogToAsset(
        simpleasset,
        listrv,
        simpleasset.assetqty,
        cteid,
        'free',
        listuse
      );

      const assets: any[] = form.getFieldValue('assets');

      if (assets.length === 0) {
        setAssetClass(asset.assetclass);
      }

      // set element.assets :
      if (form.getFieldValue('ctfclevel') === 'PROPOSAL')
        form.setFieldsValue({
          assets: [
            ...(form.getFieldValue('assets').map((asset: any) => {
              return { ...asset, assetrvamount: 0 };
            }) || []),
            asset,
          ],
        });
      else {
        assets.push(asset);
        form.setFieldsValue({
          assets: assets,
        });
      }

      form.setFieldValue('amountToUse', sumBy(assets, 'assetnetamount'));
      setSuccessful(false);
    }
    simpleAssetModal.close();
  };

  const columnsPrefinSteps = [
    {
      dataIndex: 'ctesid',
      width: 120,
      render: (val: any, record: any) => (
        <ModalControllerNV
          content={({ setVisible, visible }) => (
            <a
              onClick={() => {
                setVisible(true);
              }}
            >
              {val}
            </a>
          )}
          modal={({ setVisible, visible }) => (
            <ConElemPrefinStepModal
              visible={visible}
              onClose={() => {
                setVisible(false);
              }}
              onSave={(values, action) => {
                 onSavePreFinElement(values, 'update');
              }}
              updatePreFinStep
              record={record}
            />
          )}
        ></ModalControllerNV>
      ),
    },
    {
      dataIndex: 'ctesorder',
      width: 120,
    },

    {
      dataIndex: 'ctesstartdate',
      width: 120,
    },
    {
      dataIndex: 'ctesduration',
      width: 120,
    },
    {
      dataIndex: 'ctesperiodicityunit',
      width: 120,
    },
    {
      dataIndex: 'ctesperiodicity',
      width: 120,
    },
    {
      dataIndex: 'enddate',
      width: 120,
    },
    {
      dataIndex: 'calmethod',
      width: 120,
    },
    {
      dataIndex: 'rateformula',
      width: 120,
    },
    {
      dataIndex: 'ratebasis',
      width: 120,
    },
    {
      dataIndex: 'ratespread',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'nominalrate',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesstartamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesinterestamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesamortizedcoef',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesamortizedamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesrentalamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesoutstandingcoef',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesoutstandingamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },

    {
      dataIndex: 'action',
      width: 120,
      render: (val: number, record: any) => (
        <PopoverController>
          {({ setVisible, visible }) => (
            <Popover
              placement="bottomRight"
              visible={visible}
              trigger="click"
              onVisibleChange={setVisible}
              content={
                <DeleteButton
                  onlyIcon
                  onClick={(e) => {
                    // onDeletePrefinSteps(record.ctesid);
                  }}
                />
              }
            ></Popover>
          )}
        </PopoverController>
      ),
    },
  ];

  return (
    <DF.Provider pagcode="TabTPAuthuse">
      <Form form={form} initialValues={initialValues} layout="vertical">
        <Tabs defaultActiveKey="1" animated>
          {displayAssets && (
            <TabPane tab={<GetLabel label="assets" />} key="1">
              <Card style={{ padding: 10 }}>
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    const assets = getFieldValue('assets');

                    return (
                      <AssetsTable
                        reftechProp={() => {
                          console.log();
                        }}
                        currcode="EUR"
                        assets={assets}
                        onAddFromCatalog={handleAddFromCatalog}
                        onAddFromCatalogPack={handleAddFromCatalogPack}
                        onCreateNewAsset={handleCreateNewAsset}
                        onCreateNewMultiCompAsset={
                          handleCreateNewMultiCompAsset
                        }
                        onAddFromStock={handleAddFromStock}
                        onAddInitAsset={handleAddInitAsset}
                        onSaveAsset={() => {}}
                        onDelete={(asset) => handleDeleteAsset(asset.assetid)}
                        phase="PROPOSAL"
                        // flagreal={Boolean(getFieldValue('flagrealestate'))}
                        fromproposal
                        // proposalData={{
                        //   pricing: getFieldValue('pricing'),
                        //   prcode: getFieldValue('prcode'),
                        //   duration: getFieldValue(
                        //     getName('cteduration', elementID)
                        //   ),
                        //   offerid: getFieldValue('offerid'),
                        // }}
                        mfuse={false}
                        flagreal={false} // ctstatus={ctstatus}
                        onMoveToNewelement={function (asset: any): void {
                          throw new Error('Function not implemented.');
                        }} // nbreAsset={nbreAsset}
                      />
                    );
                  }}
                </Form.Item>
              </Card>
            </TabPane>
          )}
          <TabPane tab={<GetLabel label="authUse" />} key="2">
            <Row>
              <Col span={24}>
                <Row gutter={10}>
                  <FormInput col md={8} name="authid">
                    <TpAuthorizationSelect
                      allowClear
                      onSelect={(e: any) => {
                        setTpAuth(e);
                        setAuthDetail(e);
                        form.setFieldsValue({
                          authdetailid: 0,
                        });
                      }}
                      activedata
                      tpid={objectid}
                    />
                  </FormInput>
                  <FormInput col md={8} name="authdetailid">
                    <TpAuthorizationUseSelect
                      authDetailList={tpAuthDetail ?? []}
                      allowClear
                      onSelected={(e: any) => {
                        const myAssets: any[] = form.getFieldValue('assets');
                        let assetLabel = '';
                        if (myAssets.length) {
                          assetLabel = myAssets[0]?.assetLabel;
                        }
                        
                        setBeneficiaries(e);

                        form.setFieldsValue({
                          event: 'tabTpAuthorizationUse',
                          authdetailamount: e?.authdetailamount,
                          authdetailavailableamount:
                            e?.authdetailavailableamount,
                          // amountToUse: e?.authdetailavailableamount,
                          authbookedamount: e?.authbookedamount,
                          authdetailusedamount: e?.authdetailusedamount,
                          prcodelabel: e?.prcodelabel,
                          prcode: e?.prcode,
                          offerid: e?.offerid,
                          offerlabel: e?.offerlabel,
                          ofrtype: e?.ofrtype,
                          ofrtypelabel: e?.ofrtypelabel,
                          ofridlabel: e?.ofridlabel,
                          ofrid: e?.ofrid,
                          tpid: objectid,
                          beneficiaryname: clientName,
                          beneficiaryreference: entityReference,
                          usecomment: assetLabel,
                        });
                        handleOfferChange(e.offerid);
                      }}
                    />
                  </FormInput>
                </Row>
                <Row gutter={30}>
                  <UtinaCard comcode="Summary" level={5} lg={6}>
                    <FormInput col md={12} name="authdetailamount">
                      <Text>
                        {toCurrency(
                          form.getFieldValue('authdetailamount'),
                          tpAuth?.currcode ??
                            localStorage.getItem('currcode') ??
                            ''
                        )}
                      </Text>
                    </FormInput>
                    <FormInput col md={12} name="authdetailavailableamount">
                      <Value
                        formatter={(value) =>
                          toCurrency(
                            value,
                            tpAuth?.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )
                        }
                      />
                    </FormInput>
                    <FormInput col md={12} name="authbookedamount">
                      <Value
                        formatter={(value) =>
                          toCurrency(
                            value,
                            tpAuth?.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )
                        }
                      />
                    </FormInput>
                    <FormInput col md={12} name="authdetailusedamount">
                      <Value
                        formatter={(value) =>
                          toCurrency(
                            value,
                            tpAuth?.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )
                        }
                      />
                    </FormInput>
                  </UtinaCard>
                  <UtinaCard comcode="newUse" level={5} lg={9}>
                    <Row gutter={8}>
                      <FormInput col xs={24} name="beneficiary">

                        <ThirdpartyAuthBeneficiarySelect data={authBeneficiaryList}/>

                      </FormInput>
                      <FormInput col md={12} name="tpidfinalclient">
                        <ThirdPartyInput />
                      </FormInput>

                      <FormInput col xs={12} name="freeperiod">
                       <InputNumber/>
                      </FormInput>

                      <FormInput col md={12} name="prcodelabel">
                        <Value value={form.getFieldValue('prcodelabel')} />
                      </FormInput>

                      <FormInput col md={12} name="prcode" hidden>
                        <Input hidden />
                      </FormInput>

                      <FormInput col md={12} name="offerlabel">
                        <Value value={form.getFieldValue('offerlabel')} />
                      </FormInput>

                      <FormInput col md={12} name="pricingtype">
                        <Value value={form.getFieldValue('ofrtypelabel')} />
                      </FormInput>

                      <FormInput col md={12} name="pricing">
                        <Value value={form.getFieldValue('ofridlabel')} />
                      </FormInput>

                      <FormInput col md={24} name="amountToUse">
                        <InputCurrency
                          currcode={
                            tpAuth?.currcode ??
                            localStorage.getItem('currcode') ??
                            ''
                          }
                        />
                      </FormInput>
                      <FormInput
                        col
                        md={12}
                        name="startDate"
                        rules={[{ required: true }]}
                      >
                        <DatePicker
                          onChange={(e: any) => {
                            var init = moment(dateToString(e), 'YYYY-MM-DD');
                            var target = init
                              .add(form.getFieldValue('duration') ?? 0, 'M')
                              .subtract(1, 'd');
                            form.setFieldsValue({
                              endDate: dateToString(target),
                            });
                          }}
                        />
                      </FormInput>
                      <FormInput col md={12} name="duration">
                        <Input
                          onChange={(e: any) => {
                            let startdate =
                              form.getFieldValue('startDate') ?? moment();
                            var init = moment(dateToString(startdate));
                            var target = init
                              .add(form.getFieldValue('duration'), 'M')
                              .subtract(1, 'd');
                            form.setFieldsValue({
                              endDate: dateToString(target),
                            });
                          }}
                        />
                      </FormInput>

                      <FormInput
                        col
                        xs={12}
                        name="periodicity"
                        comcode="periodicity"
                      >
                        <ParListSelect parcode="PREFINPER" />
                      </FormInput>
                      <FormInput col md={12} name="endDate">
                        <Value />
                      </FormInput>
                    </Row>
                  </UtinaCard>
                  <UtinaCard comcode="rate" level={5} lg={8}>
                    <Row gutter={[8, 8]}>
                      <FormInput col xs={24} name="calculationtype">
                        <ParListSelect parcode="CALMETHOD" disabled />
                      </FormInput>
                      {prefinmethod !== 'PREFINSTEP' ? (
                        <>
                          <FormInput
                            col
                            xs={24}
                            name="ratetype"
                            comcode="ratetype"
                          >
                            <ParListSelect parcode="RATETYPE" disabled />
                          </FormInput>
                          <FormInput
                            col
                            xs={24}
                            name="rateformula"
                            comcode="rateformula"
                          >
                            <RateFormulaSelect
                              params={{
                                formulatype: form.getFieldValue('ratetype'),
                              }}
                              disabled
                            />
                          </FormInput>
                          <FormInput
                            col
                            xs={24}
                            name="rateref"
                            comcode="rateref"
                          >
                            <Value
                              formatter={() =>
                                toRate(form.getFieldValue('rateref'))
                              }
                            ></Value>
                          </FormInput>
                          <FormInput
                            col
                            xs={24}
                            name="ratespread"
                            comcode="ratespread"
                          >
                            <InputRate onChange={(val) => {}} />
                          </FormInput>
                          <FormInput
                            col
                            xs={24}
                            name="nominalrate"
                            comcode="nominalrate"
                          >
                            <InputRate
                              value={form.getFieldValue('nominalrate')}
                            />
                          </FormInput>
                        </>
                      ) : (
                        <>
                          <Form.Item shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              return (
                                <FormInput
                                  col
                                  xs={24}
                                  md={24}
                                  name="ctepartmethod"
                                  comcode="ctepartmethod"
                                >
                                  <ParListSelect
                                    parcode="CTEPARTMET"
                                    offerid={getFieldValue('offerid')}
                                  />
                                </FormInput>
                              );
                            }}
                          </Form.Item>
                          <Form.Item shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              return (
                                <InputCurrency
                                  col
                                  md={24}
                                  disabled={
                                    getFieldValue('ctepartmethod') === 'POURC'
                                  }
                                  currcode={getFieldValue('currcode')}
                                  comcode="ctepartamount"
                                  fieldname="ctepartamount"
                                />
                              );
                            }}
                          </Form.Item>
                          <FormInput
                            col
                            xs={24}
                            md={24}
                            comcode="ctepartrate"
                            name="ctepartrate"
                          >
                            <InputRate
                              style={{ width: '100%' }}
                              disabled={
                                form.getFieldValue('ctepartmethod') === 'FIXED'
                              }
                            />
                          </FormInput>

                          <FormInput
                            col
                            xs={24}
                            md={24}
                            comcode="ctepartnbdays"
                            name="ctepartnbdays"
                            tooltip={
                              'Max : ' + form.getFieldValue('ctepartnbdaysmax')
                            }
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              max={form.getFieldValue('ctepartnbdaysmax')}
                            />
                          </FormInput>

                          <FormInput
                            col
                            xs={24}
                            md={24}
                            comcode="tpidparticipation"
                            name="tpidparticipation"
                          >
                            <ThirdPartyInput onlytpid />
                          </FormInput>
                        </>
                      )}
                    </Row>
                  </UtinaCard>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <FormInput
                    labelCol={{ span: 24 }}
                    col
                    md={24}
                    name="usecomment"
                  >
                    <TextArea rows={5} />
                  </FormInput>
                </Row>
              </Col>
            </Row>
          </TabPane>

          {prefinmethod === 'PREFINSTEP' && (
            <TabPane tab={<GetLabel label="tabprefinsteps" />} key={34}>
              <Card>
                <Row justify="end">
                  <Form.Item shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      return (
                        <FinancialScheduleModal
                          finElement={finElement}
                           currcode={getFieldValue('currcode')}
                          data={getFieldValue('elements')}
                          comcode="globalSchedule"
                          loading={loading}
                          controller={
                            <ScheduleButton
                              size="large"
                              comcode="globalSchedule"
                              twoToneColor={
                                isNil(getFieldValue('offerid'))
                                  ? 'gray'
                                  : 'green'
                              }
                              disabled={isNil(getFieldValue('offerid'))}
                            ></ScheduleButton>
                          }
                        />
                      );
                    }}
                  </Form.Item>
                </Row>
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    const _prefinStepsList = getFieldValue('_prefinStepsList');
                    return (
                      <>
                        <Row justify="end">
                          <ModalControllerNV
                            content={({ setVisible, visible }) => (
                              <>
                                <ButtonOperation
                                  onClick={() => {
                                    setVisible(true);
                                  }}
                                  type="primary"
                                  comcode="add"
                                />
                                <ButtonOperation
                                  onClick={() => {
                                    calculatePaymentShedulePrefinSteps(
                                      finElement
                                    );
                                  }}
                                  htmlType="button"
                                  comcode="calculate"
                                />
                              </>
                            )}
                            modal={({ setVisible, visible }) => (
                              <ConElemPrefinStepModal
                                visible={visible}
                                onClose={() => {
                                  setVisible(false);
                                }}
                                ctesorder={1 + _prefinStepsList?.length ?? 0}
                                onSave={(values, action) => {
                                  const newConElemPrefinStepsList: any[] =
                                    _prefinStepsList ?? [];
                                  newConElemPrefinStepsList?.push();
                                  form.setFieldValue(
                                    '_prefinStepsList',
                                    newConElemPrefinStepsList
                                  );
                                }}
                                record={undefined}
                              />
                            )}
                          ></ModalControllerNV>
                        </Row>

                        <DataGrid
                          dataSource={_prefinStepsList ?? []}
                          pagination={false}
                          columns={columnsPrefinSteps}
                          titleComcode="conElemPrefinSteps"
                          rowKey={(e) => e.ctesid}
                        />
                      </>
                    );
                  }}
                </Form.Item>
              </Card>
            </TabPane>
          )}
        </Tabs>
      </Form>

      <AssetCatalogModal
        currcode={form.getFieldValue('currcode')}
        network={form.getFieldValue('ctnetworkcode')}
        onCancel={catalogModal.close}
        onSelect={() => {}}
        visible={catalogModal.visible}
      />

      <AssetCatalogPackModal
        currcode={form.getFieldValue('currcode')}
        onCancel={catalogPackModal.close}
        onSelect={() => {}}
        visible={catalogPackModal.visible}
      />

      <AssetListModalV
        alreadySelected={getAssetListId()}
        visible={assetModalVisible}
        onCancel={() => {
          setAssetModalVisible(false);
        }}
        phase="PROPOSAL"
        status={assetstatus}
        assetClass={assetClass}
        validate={handleSelectAssetFromStockOrInit}
        nbreAsset={1}
      />
      {/*assetMultiCompModal.visible === true ? (
        <AssetDetails
          asset={null}
          onCancel={() => assetMultiCompModal.close()}
          showAsModal
          visible={assetMultiCompModal.visible}
          onSave={(asset) => {
            handleSaveAsset && handleSaveAsset(asset);
          }}
          phaseprop={phase}
          fromproposal
          flagreal={Boolean(form.getFieldValue('flagrealestate'))}
        />
        ) : null*/}

      <Form.Item shouldUpdate>
        {({ getFieldValue }) => {
          return (
            <SimpleAssetModal
              flagreal={Boolean(form.getFieldValue('flagrealestate'))}
              supplier={
                form.getFieldValue('prcode') === 'LEASEBACK'
                  ? form.getFieldValue('client')
                  : null
              }
              onAdd={handleAddSimpleAsset}
              onCancel={simpleAssetModal.close}
              currcode={form.getFieldValue('currcode')}
              visible={simpleAssetModal.visible}
              assetclass={assetClass}
            />
          );
        }}
      </Form.Item>
    </DF.Provider>
  );
};

type UseOfferListParams = {
  catalogid?: number;
  duration?: number;
  filtersList?: prFilteringCriteria;
  filters?: string;
  finamount?: number;
  prcode?: string;
  searchMode: string; // PRCODE : by prcode, CATALOG : bu Catalog, FIN : by FinaMount and Duration
};

const useOfferList = (params: UseOfferListParams) => {
  const {
    prcode,
    duration,
    finamount,
    filters = '',
    filtersList,
    searchMode,
  } = params;

  const getOfferListRequest = useQuery(
    ['getOfferList', { duration, filters, finamount }, prcode],
    () =>
      getprOfferList({
        duration: duration!,
        filters,
        finamount: finamount!,
        prcode: prcode!,
      }).then((res) => res.list || []),
    { enabled: searchMode === 'FIN' }
  );

  const getOfferListByPrcodeAndMgidRequest = useQuery(
    ['getOfferListByPrcodeAndMgid', { filtersList, prcode }, prcode],
    () =>
      getprOfferListByPrcodeAndMgid({
        filters: filtersList!,
      }).then((res) => res.list || []),
    { enabled: searchMode === 'PRCODE' }
  );

  switch (searchMode) {
    case 'FIN':
      return getOfferListRequest;

    /*  case 'CATALOG':
      return getOfferListByCatalogIDRequest;
*/
    case 'PRCODE':
      return getOfferListByPrcodeAndMgidRequest;
    default:
      return getOfferListByPrcodeAndMgidRequest;
  }
};

export default TabTpAuthorizationUse;
